<template>
  <!-- Content Wrapper. Contains page content -->
  <div id="content-wrap" class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Marketing
        <small>Version 2.0</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Marketing</li>
      </ol>
    </section>

    <section class="content">
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
export default {
  name: 'Marketing'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/marketing/Marketing.vue